// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2qHJ2","validationTips":"StatementDescriptor_validationTips__3AmWo"};